module.exports = __webpack_public_path__ + "static/mellisa-c1072073771d9b060bbf365d62982591.png";